import { createAction } from '@reduxjs/toolkit';
import type { PollworkerModuleInfo } from 'admin/src/types/Pollworker/PollworkerModuleInfo';

export const MODULE_INFO_ACTION_TYPES = {
  SET_MODULE_INFO: 'SET_MODULE_INFO',
};

export const setModuleInfo = createAction<PollworkerModuleInfo>(MODULE_INFO_ACTION_TYPES.SET_MODULE_INFO);
